interface TrackerOptions {
    hash: string;
    request: {
        uri: string;
        token: string;
    }
}

const defaultTrackerOptions = {
    hash: '',
    request: {
        uri: '',
        token: ''
    }
};

class Tracker {
    protected options: TrackerOptions = defaultTrackerOptions;
    protected isTracked: boolean = false;

    constructor(opt: TrackerOptions) {
        this.options = Object.assign(this.options, {
            hash: '',
            request: {
                uri: '',
                token: ''
            }
        }, opt);
    }

    public count() {
        if(this.options.request.uri != '') {
            window.addEventListener('mousemove', () => {
                this.track();
            }, { once: true });
            window.addEventListener('click', () => {
                this.track();
            }, { once: true });
            window.addEventListener('scroll', () => {
                this.track();
            }, { once: true });
        }
    }

    private track() {
        if(!this.isTracked) {
            window.setTimeout(() => {
                this.send();
            }, 1000);
        }
        this.isTracked = true;
    }

    private send() {
        let metrics = 'i';
        const ts = new Date().getTime();
        if(window.sessionStorage && this.options.hash) {
            const sts = window.sessionStorage.getItem(this.options.hash) ?? '0';
            if(parseInt(sts) < ts) {
                window.sessionStorage.setItem(this.options.hash, (ts+1800000).toString());
                metrics += ',v';
            }
        }

        const data = {
            token: this.options.request.token,
            metrics: metrics,
            ts: ts
        };

        fetch(this.options.request.uri, {
            method: 'post',
            headers: {
                "Accept": "application/json",
            },
            body: JSON.stringify(data)
        });
    }
}

export { Tracker, type TrackerOptions };
